export { encodeBech32, decodeBech32 } from '../lib/Amino';
